import type { NavigationGuard } from 'vue-router';
import { getMsal } from './msal';

// Authenticated routes (those carrying `meta.requiresAuth`) require an MSAL account. If one
// is missing we redirect to the public landing page (`/`) rather than triggering the MSAL
// redirect inline — the landing page surfaces the product and a deliberate Sign-in button,
// which gives the operator a chance to see what they're being asked to sign into. The
// landing view itself triggers `loginRedirect` when the operator clicks Sign in.
export const authGuard: NavigationGuard = async (to) => {
  if (!to.meta.requiresAuth) return true;

  const accounts = getMsal().getAllAccounts();
  if (accounts.length === 0) {
    return { path: '/' };
  }
  return true;
};
